import {createSelector} from 'reselect';
import {State} from '../../../types/mx/reducers';

const getRFC = (state: State) =>
    state.creditoReal?.loanApplication?.applicantPersonal?.docNumber || '';

export const rfcErrorSelector = createSelector(
    [getRFC],
    (rfc) => rfc !== "" && rfc.length < 13
);
